var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.entity)?_c('div',{staticStyle:{"border":"1px solid green","padding":"10px"}},[_c('EntityZ',{attrs:{"entity":_vm.entity}}),_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }